module.exports = __webpack_public_path__ + "static/media/Group_543.b067cff7.png";